module.exports = __webpack_public_path__ + "img/illustration-step-3-02.220f83e7.svg";